import { IonFooter, IonHeader, IonMenuToggle } from '@ionic/react'
import { additionalLinks } from '~/widgets/layout/main/ui/Menu/constants'
import { MenuType } from '~/widgets/layout/main/ui/Menu/type'
import { MainTaxipark } from '~/widgets/MainTaxipark'
import { pushFx } from '~/shared/lib/history'
import { Logo } from '~/shared/ui/Logo'
import { MAIN_LAYOUT_MENU_ID } from '~/shared/ui/theme/theme'
import { useMenu } from './hooks/useMenu'
import {
  AdditionalLink,
  IonToolbarCustom,
  IconWrapper,
  IonContentCustom,
  ItemWrapper,
  ItemTitle,
  IonMenuCustom,
} from './styled'

export function Menu() {
  const menus = useMenu()

  const handleMenuSelected = (menu: MenuType) => {
    if (menu.fn) menu.fn()
    if (menu.to) pushFx(menu.to)
    if (menu.href) window.open(menu.href, '_blank')
  }

  return (
    <IonMenuCustom
      menuId='main-menu'
      contentId={MAIN_LAYOUT_MENU_ID}
      maxEdgeStart={0}
    >
      <IonHeader>
        <IonToolbarCustom>
          <Logo />
        </IonToolbarCustom>
      </IonHeader>

      <IonContentCustom fullscreen>
        <div style={{ marginBottom: '12px' }}>
          <MainTaxipark />
        </div>

        {menus.map((menu) => (
          <IonMenuToggle
            key={menu.title}
            autoHide
            onClick={() => handleMenuSelected(menu)}
          >
            <ItemWrapper>
              <IconWrapper>{menu.icon}</IconWrapper>
              <ItemTitle>{menu.title}</ItemTitle>
            </ItemWrapper>
          </IonMenuToggle>
        ))}
      </IonContentCustom>
      <IonFooter>
        <IonToolbarCustom>
          {additionalLinks.map((link) => (
            <AdditionalLink key={link.to} to={link.to} target='_blank'>
              {link.title}
            </AdditionalLink>
          ))}
        </IonToolbarCustom>
      </IonFooter>
    </IonMenuCustom>
  )
}
